import type { RemoteParticipant } from 'livekit-client';
import { hasModeratorRole, isHostRole, resolveRoleFromMetadata } from './participantRoles';

/**
 * LiveKit passes the authenticated sender on RoomEvent.DataReceived.
 * Moderation payloads must not be trusted from JSON fields like `from` alone.
 */
export function isTrustedModerationSender(participant: RemoteParticipant | undefined): boolean {
  if (!participant) {
    return false;
  }
  const role = resolveRoleFromMetadata(participant.metadata);
  return hasModeratorRole(role);
}

/** Role assignment (co-host) should only be accepted from the room host. */
export function isTrustedHostSender(participant: RemoteParticipant | undefined): boolean {
  if (!participant) {
    return false;
  }
  const role = resolveRoleFromMetadata(participant.metadata);
  return isHostRole(role);
}
